import { ParentSize } from "@visx/responsive";

import HorizontalBarChart, {
  HorizontalBarChartProps,
} from "./HorizontalBarChart";
import VerticalBarChart, { VerticalBarChartProps } from "./VerticalBarChart";

export type BarChartProps = (
  | VerticalBarChartProps
  | HorizontalBarChartProps
) & { width?: number; height?: number };

const BarChartWithParentSize = (props: BarChartProps) => {
  return (
    <ParentSize>
      {({ width, height }) => {
        return props.orientation === "horizontal" ? (
          <HorizontalBarChart
            {...props}
            width={props.width ?? width}
            height={props.height ?? height}
          />
        ) : (
          <VerticalBarChart
            {...props}
            width={props.width ?? width}
            height={props.height ?? height}
          />
        );
      }}
    </ParentSize>
  );
};
export default BarChartWithParentSize;
